import { FilePlus } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/** Notes' app-wide palette entry: a new note, created by the view for `?new=note`. */
export const notesCommands: CommandFactory = ({ router, t, appLabel: notes }) => [
  appLocationCommand(router, {
    id: 'notes.newNote',
    app: 'notes',
    group: notes,
    label: `${notes}: ${t('notes.note.new')}`,
    href: '/notes?new=note',
    icon: FilePlus,
    keywords: ['notes', 'notiz', 'notizen', 'note', 'neu', 'new', 'zeichnen'],
  }),
];
